import './puffnstuff/style';
import FormStructure from './puffnstuff/form_structure';

export default FormStructure;